import { render, staticRenderFns } from "./Corso.vue?vue&type=template&id=3c612d17&scoped=true&"
import script from "./Corso.vue?vue&type=script&lang=js&"
export * from "./Corso.vue?vue&type=script&lang=js&"
import style0 from "./Corso.vue?vue&type=style&index=0&id=3c612d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c612d17",
  null
  
)

export default component.exports